import type { SxProps, Theme } from '@mui/material';

export const buttonSx: SxProps<Theme> = {
  width: '45%',
  borderRadius: '8px',
  boxShadow: 'none',
  marginLeft: '0 !important',
};
